module.exports = __webpack_public_path__ + "img/list_Character_sq_02.8760b146.jpeg";